import script from "./MessageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageDetail.vue?vue&type=script&setup=true&lang=js"

import "./MessageDetail.vue?vue&type=style&index=0&id=6a2c4f32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a2c4f32"]])

export default __exports__